import { TableColumnModel } from '../../../../../Common/Forms/models/table-column.model';

export const templateTypeColumnConfig: TableColumnModel = {
    heading: 'Briefings.templateManageDialog.column.templateType',
    field: 'type',
    tooltipField: 'type',
    sortable: true,
    sortType: 'text',
    showInfoCircle: true,
    maxWidth: 150
};
